import BaseComponent from '../../../js/base-component';
import { Modal } from '../../../js/modal';

class CareProductsStepThree extends BaseComponent {
    constructor(element) {
        super(element);

        let additionalCareProducts = this.element.querySelectorAll('input[name="additionalCareProducts"]') || '';
        let checked = this.element.querySelector('input[name="additionalCareProducts"]:checked').value;
        let products = document.querySelector('#products') || '';
        const requiredFields = products.querySelectorAll(':required') || '';

        additionalCareProducts.forEach((ele) => {
            ele.addEventListener("click", (e) => { this.checkRadio( e.target.value, products, requiredFields ) });
        });

        this.checkRadio( checked, products, requiredFields );

        this.packageButton = this.element.querySelector('.u-edit--package');
        this.packageModalContainer = document.querySelector('#packageModal') || '';
        this.packageModal = new Modal( this.packageModalContainer );

        this.packageButton.addEventListener('click', (evt) => {
            this.packageModal.handleModal('package','open', {id: element.dataset.id, contract: element.dataset.contract});
        });
    }

    onInit() {}

    checkRadio = (state, ele, required)  => {
        if ( state === '0' ) {
           ele.classList.add('hidden');
        }

        if ( state === '1' ) {
            ele.classList.remove('hidden');
        }

         // add/remove required attribte of formfields
         this.setRequiredFields(state, required);
    }

    setRequiredFields = (state, required) => {
        // remove required attribute of formfields
        if ( state === '0' ) {
             required.forEach(ele => {
                 ele.removeAttribute("required");
             });
         }

         // add required attribute if not present
        if ( state === '1' ) {
            required.forEach(ele => {
                if (!ele.hasAttribute("required")) {
                    ele.setAttribute("required","");
                }
            });
        }
    }
}

export default {
    name: 'CareProductsStepThree',
    definition: CareProductsStepThree
};